import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Bounce } from 'react-reveal';
import { Button,  Form, Icon, Input, Loader, Modal, Pagination, TextArea } from 'semantic-ui-react';
import GConf from '../../../AssetsM/generalConf';
import {toast } from 'react-toastify';
import { useParams } from 'react-router-dom';

function RapportPage() {
    let {de,vers} = useParams()
    
    let [reternedeData, setReternedData] = useState({bonsCaisse:[], compteAymen:0,compteDepot:0,compteProduitMG:0,compteSodexo:0, });
    let [caissesR, setCaisseR] = useState([])
    let [caissesD, setCaisseD] = useState([])
    let [electroR, setElectroR] = useState([])
    let [revenueListe, seRevenueData] = useState([])
    let [depenseData, setDepenseData] = useState([])
    let [sarefData, setSarefData] = useState([])
    let [bonsData, setBonsData] = useState([])
    let [mgDepotData, setMgDepotData] = useState([])
    

    useEffect(()=>{
        axios.post(`${GConf.ApiLink}/tools/rapport`, {
            targetDay : {start:de, end:vers}
        })
        .then(function (response) {                
             
            console.log(response.data)
            setReternedData(response.data)
            setCaisseR(response.data.revenueCaisse)
            setCaisseD(response.data.depenseCaisse)

            let RevenueList = response.data.budget.filter((data) => data.Subgenre === 'REVENUE')
            seRevenueData(RevenueList)

             
            let DepenseList = response.data.budget.filter((data) => data.Subgenre === 'DEPENSES')
            setDepenseData(DepenseList)

           
            let DepotList = response.data.budget.filter((data) => data.Subgenre === 'DEPOT')
            setMgDepotData(DepotList)
            
             
            let SarefList = response.data.budget.filter((data) => data.Subgenre === 'SAREF')
            setSarefData(SarefList)
            
          
            let BonsList = response.data.budget.filter((data) => data.Subgenre === 'BONS')
            setBonsData(BonsList)


        }).catch((error) => {
            if(error.request) {
              toast.error(<><div><h5>Probleme de Connextion</h5>  </div></>, GConf.TostInternetGonf)   
            }
          });
    },[])
    
    const WriteCaisseName = (caisseID) => {
        if (caisseID == 1111111111) { return 'CAISSE 1'
            
        } else {
            return 'CAISSE 2'
        }
    }

    const CalculateTotaleBons = (caisseID) => {
        let rows = reternedeData.bonsCaisse.filter((data) => data.Caisse_ID == caisseID)
        let nette = 0
        let rended = []
        for (var i = 0; i < rows.length ; i++) {
            let item = JSON.parse(rows[i].Paye_Bons);
            //for (var k = 0; k < item.length; k++) {
                rended.push(item)
            //}
        }
        console.log(rended)
        const groupedData = Object.values(rended.reduce((acc, item) => {
            if (!acc[item.bon]) {
                acc[item.bon] = { ...item }; // Clone the object
            } else {
                acc[item.bon].qte += item.qte; // Sum qte values
            }
            return acc;
        }, {}));
        
        groupedData.map((data) => {
            nette = nette + ( data.qte * data.valeur)
        })
        return nette.toFixed(3)
    }

    return ( <>
            <div className='container'>
                <h5>Rapport de : {de} , vers : {vers} </h5> 
                <br /> 
                <div className="row">
                    <h5 className='text-danger'>REVENUE CAISSES  : </h5>
                    <table>
                        <tr>
                            <td>Date</td>
                            <td>Caisse 1</td>
                            <td>Caisse 2</td>
                        </tr>
                        {caissesR.map((data,index) => <tr key={index}> <td>{new Date(data.RC_Date).toLocaleDateString('fr-FR').split( '/' ).join( '-' )}</td>  <td>{data.Caisse_1}</td> <td>{data.Caisse_2}</td></tr>)}
                    </table>
                     

                    <h5 className='text-danger mt-4'>DEPENSES CAISSES  : </h5>
                    <table>
                        <tr>
                            <td>Date</td>
                            <td>Ciasse</td>
                            <td>Depenses</td>
                            <td>Description</td>
                        </tr>
                        {caissesD.map((data,index) => <tr key={index}><td>{new Date(data.D_Date).toLocaleDateString('fr-FR').split( '/' ).join( '-' )} </td>  <td> {WriteCaisseName(data.Caisse_ID)} </td>  <td> {data.Valeur}</td>  <td> {data.Description}</td></tr>)}
                    </table>

                    <h5 className='text-danger mt-4'>REVENUE INTERNE & SAREF : </h5>
                    <table>
                        <tr>
                            <td>Date</td>
                            <td>Valeur</td>
                            <td>Description</td>
                        </tr>
                        {revenueListe.map((data,index) => <tr key={index}>  <td> {new Date(data.DB_Date).toLocaleDateString('fr-FR').split( '/' ).join( '-' )} </td>  <td> {data.BD_Value} </td>  <td> {data.DB_Description} </td></tr>)}
                        {sarefData.map((data,index) => <tr key={index}>  <td> {new Date(data.DB_Date).toLocaleDateString('fr-FR').split( '/' ).join( '-' )} </td>  <td> {data.BD_Value} </td>  <td> {data.DB_Description} </td></tr>)}
                    </table>


                    <h5 className='text-danger mt-4'>DEPENSES INTERNE  : </h5>
                    <table>
                        <tr>
                            <td>Date</td>
                            <td>Valeur</td>
                            <td>Description</td>
                        </tr>
                        {depenseData.map((data,index) => <tr key={index}>  <td> {new Date(data.DB_Date).toLocaleDateString('fr-FR').split( '/' ).join( '-' )} </td>  <td> {data.BD_Value} </td>  <td> {data.DB_Description} </td></tr>)}
                    </table>
                    

                    <h5 className='text-danger mt-4'>MAGAZIN DEPOT   : </h5>
                    <table>
                        <tr>
                            <td>Date</td>
                            <td>Valeur</td>
                            <td>Description</td>
                        </tr>
                        {mgDepotData.map((data,index) => <tr key={index}>  <td> {new Date(data.DB_Date).toLocaleDateString('fr-FR').split( '/' ).join( '-' )} </td>  <td> {data.BD_Value} </td>  <td> {data.DB_Description} </td></tr>)}
                    </table>

                


                    <h5 className='text-danger mt-4'>BONS : </h5>
                    <table>
                        <tr>
                            <td>Caisse</td>
                            <td>Totale</td>
                        </tr>
                        <tr>
                            <td>Caisse 1 </td>
                            <td>{CalculateTotaleBons(1111111111)}</td>
                        </tr>
                        <tr>
                            <td>Caisse 2 </td>
                            <td>{CalculateTotaleBons(2222222222)}</td>
                        </tr>
                        {/* {bonsData.map((data,index) => <tr key={index}>  <td> {new Date(data.DB_Date).toLocaleDateString('fr-FR').split( '/' ).join( '-' )} </td>  <td> {data.BD_Value} </td>  <td> {data.DB_Description} </td></tr>)} */}
                    </table>
                    <h5 className='text-danger mt-4'> COMPTE DE CREDIT SPESIALE  : </h5>
                    <table>
                        <tr>
                            <td>Compte</td>
                            <td>Totale </td>
                        </tr>
                        <tr>
                            <td>COMPTE DEPOT </td>
                            <td> {reternedeData.compteDepot ? reternedeData.compteDepot.toFixed(3) : '0.000'} </td>
                        </tr>
                        <tr>
                            <td>COMPTE AYMEN & MAISON </td>
                            <td> {reternedeData.compteAymen ? reternedeData.compteAymen.toFixed(3) : '0.000'} </td>
                        </tr>
                        <tr>
                            <td>COMPTE SODEXO </td>
                            <td> {reternedeData.compteSodexo ? reternedeData.compteSodexo.toFixed(3) : '0.000'} </td>
                        </tr>
                        <tr>
                            <td>COMPTE PRODUIT MAGAZIN </td>
                            <td> {reternedeData.compteProduitMG ? reternedeData.compteProduitMG.toFixed(3) : '0.000'} </td>
                        </tr>

                    </table>
                     

                </div>
            </div>
    </> );
}

export default RapportPage;